
import { defineComponent } from "vue"
import { WYF_STORIES } from "@/utils/wyf-stories"

export interface Story {
  name: string
  location: string
  text: string
  photo: string
}

export default defineComponent({
  data: () => ({
    dialogStory: undefined as Story | undefined,
    isDialogOpen: false,
  }),

  computed: {
    stories (): Story[] {
      return WYF_STORIES.map(story => ({
        ...story,
        name: this.$fmt.localize(story.name) as string,
        location: this.$fmt.localize(story.location) as string,
        text: this.$fmt.localize(story.text) as string,
      }))
    },
  },

  methods: {
    slide (dir: 1 | -1) {
      const SLIDE_W = 328
      if (this.$refs.storiesRef)
        (this.$refs.storiesRef as HTMLElement).scrollLeft += SLIDE_W * dir
    },

    openDialog (story: Story) {
      this.dialogStory = story
      this.isDialogOpen = true
    },
  },
})
